module.exports = __webpack_public_path__ + "static/media/bphtb4.c561ae52.png";